import React from "react";
import { useTable } from "react-table";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import styled from "styled-components";
import SimpleBar from "simplebar-react";
import { handleDragEnd } from "../helper";
const Tr = styled.tr`
    background-color: white;
    display: ${({ isDragging }: any) => (isDragging ? "table" : "")};
    transition: background-color 0.3s ease;

    ${({ isDragging }: any) =>
        isDragging &&
        `
        background-color: #f0f0f0;
        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    `}
`;

export function Table({ columns, data, deviceType, section, path }: any) {
    const { getTableProps, headerGroups, prepareRow, rows } = useTable({
        columns,
        data,
    });

    return (
        <table {...getTableProps()}>
            <thead>
                {headerGroups.map((headerGroup: any) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column: any) => (
                            <th {...column.getHeaderProps()}>
                                {column.render("Header")}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <SimpleBar autoHide style={{ minHeight: 200, maxHeight: 250 }}>
                <DragDropContext
                    onDragEnd={(result) =>
                        handleDragEnd(result, path, data, section, deviceType)
                    }
                >
                    <Droppable droppableId="table-body">
                        {(provided: any, snapshot: any) => {
                            return (
                                <tbody
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    className={
                                        snapshot.isDraggingOver
                                            ? "dragging-over"
                                            : ""
                                    }
                                >
                                    {rows.map((row: any, index: number) => {
                                        prepareRow(row);

                                        return (
                                            <Draggable
                                                key={
                                                    row.original.id ||
                                                    `row-${index}`
                                                }
                                                draggableId={
                                                    row.original.id ||
                                                    `row-${index}`
                                                }
                                                index={index}
                                            >
                                                {(
                                                    provided: any,
                                                    snapshot: any
                                                ) => {
                                                    return (
                                                        <Tr
                                                            ref={
                                                                provided.innerRef
                                                            }
                                                            {...provided.draggableProps}
                                                            isDragging={
                                                                snapshot.isDragging
                                                            }
                                                        >
                                                            {row.cells.map(
                                                                (cell: any) => (
                                                                    <td
                                                                        {...cell.getCellProps()}
                                                                    >
                                                                        {cell.render(
                                                                            "Cell",
                                                                            {
                                                                                dragHandleProps:
                                                                                    provided.dragHandleProps,
                                                                                isDragging:
                                                                                    snapshot.isDragging,
                                                                            }
                                                                        )}
                                                                    </td>
                                                                )
                                                            )}
                                                        </Tr>
                                                    );
                                                }}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </tbody>
                            );
                        }}
                    </Droppable>
                </DragDropContext>
            </SimpleBar>
        </table>
    );
}
